import { dashBoardIcons, icons } from "./images";
import React from "react";
import { numberOptions } from "service/utilities";
import CRMConfiguration from "pages/CRMConfiguration";
import { fetchCrmTableData } from "component/Common/API/api";
export const sideBarData = [
  {
    name: "dashboard",
    label: "Dashboard",
    to: "/dashboard/digigold",
    linkName: "/dashboard",
    image: dashBoardIcons.dashboardIcon,
    imageHighlight: dashBoardIcons.dashBoardHighlight,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "GoldRateMaintenance",
    label: "Gold Rate Maintenance",
    to: "/gold-maintenance",
    linkName: "/gold-maintenance",
    image: dashBoardIcons.goldRateIcon,
    imageHighlight: dashBoardIcons.goldRateHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "SchemeManagement",
    label: "Scheme Management",
    to: "/scheme-management",
    linkName: "/scheme-management",
    image: dashBoardIcons.schemeManagementIcon,
    imageHighlight: dashBoardIcons.schemeHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "CustomerManagement",
    label: "Customer Management",
    to: "/customer-management",
    linkName: "/customer-management",
    image: dashBoardIcons.customerManagementIcon,
    imageHighlight: dashBoardIcons.customerHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "OrderManagement",
    label: "Order Management",
    to: "/order-management",
    linkName: "/order-management",
    image: dashBoardIcons.orderManagementIcon,
    imageHighlight: dashBoardIcons.orderHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "SupportManagement",
    label: "Support Management",
    to: "/support-management",
    linkName: "/support-management",
    image: dashBoardIcons.supportManagementIcon,
    imageHighlight: dashBoardIcons.supportHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "ContentManagement",
    label: "Content Management",
    to: "/content-management/screenContent",
    linkName: "/content-management",
    image: dashBoardIcons.contentManagementIcon,
    imageHighlight: dashBoardIcons.contentHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "WorkflowManagement",
    label: "Workflow Management",
    to: "/work-management/workflow-dashboard",
    linkName: "/work-management",
    image: dashBoardIcons.work,
    imageHighlight: dashBoardIcons.work,
    isOpen: false,
    subOptions: [],
  },
  // {
  //   name: "Reporting",
  //   label: "Reporting",
  //   to: "/reporting",
  //   linkName: "/reporting",
  //   image: dashBoardIcons.reportingIcon,
  //   imageHighlight: dashBoardIcons.reportingHighlightIcon,
  //   isOpen: false,
  //   subOptions: [],
  // },
  {
    name: "Reporting",
    label: "Reports",
    to: "/reportings",
    linkName: "/reportings",
    image: dashBoardIcons.reportingIcon,
    imageHighlight: dashBoardIcons.reportingHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "Settings",
    label: "Settings",
    to: "/settings",
    linkName: "/settings",
    image: dashBoardIcons.Settings,
    imageHighlight: dashBoardIcons.SettingsHighlight,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "SystemConfigsettings",
    label: "System Config settings",
    to: "/system-config",
    linkName: "/system-config",
    image: dashBoardIcons.dashboardIcon,
    imageHighlight: dashBoardIcons.dashBoardHighlight,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "UserManagement",
    label: "User Management",
    to: "/user-management",
    linkName: "/user-management",
    image: dashBoardIcons.userManagementIcon,
    imageHighlight: dashBoardIcons.userHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "exportUserList",
    label: "Export Users",
    to: "/export-users",
    linkName: "/export-users",
    image: dashBoardIcons.userManagementIcon,
    imageHighlight: dashBoardIcons.userHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "ReferralManagement",
    label: "Referral Management",
    to: "/referral-Management",
    linkName: "/referral-Management",
    image: dashBoardIcons.referral,
    imageHighlight: dashBoardIcons.referralHighlight,
    isOpen: false,
    subOptions: [
      {
        label: "Users",
        subLink: "/referral-Management/alluser/all",
        name: "referralManagementUsers",
      },
      {
        label: "Categories",
        subLink: "/referral-Management/categories",
        name: "referralManagementCategories",
      },
      {
        label: "Campaigns",
        subLink: "/referral-Management/campaigns",
        name: "referralManagementCampaigns",
      },
      {
        label: "FAQs",
        subLink: "/referral-Management/faq",
        name: "referralManagementFaqs",
      },
      {
        label: "Reports",
        subLink: "/referral-Management/reports",
        name: "referralManagementreports",
      },
      {
        label: "Employe Management",
        subLink: "/referral-Management/EmployeeManagement",
        name: "referralManagementEmployee",
      },
    ],
  },
  {
    name: "DeletionRequest",
    label: "Account Deletion Request",
    to: "/deletion-Management/deletion-request",
    linkName: "/deletion-Management",
    image: dashBoardIcons.deleteRequest,
    imageHighlight: dashBoardIcons.deleteRequestHighlight,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "ReceiptReconciliation",
    label: "Receipt Reconciliation",
    to: "/receipt-reconciliation",
    linkName: "/receipt-reconciliation",
    image: dashBoardIcons.receiptreconciliationHighlight,
    imageHighlight: dashBoardIcons.receiptreconciliation,
    isOpen: false,
    subOptions: [],
  },

  // {
  //   name: "posreporting",
  //   label: "POS Report",
  //   to: "/pos-reporting",
  //   linkName: "/pos-reporting",
  //   image: dashBoardIcons.reportingIcon,
  //   imageHighlight: dashBoardIcons.reportingHighlightIcon,
  //   isOpen: false,
  //   subOptions: [],
  // },
  // {
  //   name: "fmReporting",
  //   label: "DFM Form",
  //   to: "/DFM-Reporting",
  //   linkName: "/DFM-Reporting",
  //   image: dashBoardIcons.reportingIcon,
  //   imageHighlight: dashBoardIcons.reportingHighlightIcon,
  //   isOpen: false,
  //   subOptions: [],
  // },
  {
    name: "CrmConfiguration",
    label: "CRM Configuration",
    to: "/crm-configuration",
    linkName: "/crm-configuration",
    image: dashBoardIcons.userManagementIcon,
    imageHighlight: dashBoardIcons.userHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  {
    name: "marketingManagement",
    label: "Marketing Management",
    to: "/marketing-management",
    linkName: "/marketing-management",
    image: dashBoardIcons.reportingIcon,
    imageHighlight: dashBoardIcons.reportingHighlightIcon,
    isOpen: false,
    subOptions: [],
  },
  // {
  //   name: "Mandatereconciliation",
  //   label: "Mandate reconciliation",
  //   to: "/mandate-reconciliation",
  //   linkName: "/mandate-reconciliation",
  //   image: dashBoardIcons.userManagementIcon,
  //   imageHighlight: dashBoardIcons.userHighlightIcon,
  //   isOpen: false,
  //   subOptions: [],
  // },
];

export const getSchemeStatus = (status) => {
  let statusList = {
    0: "Setup",
    1: "Active",
    3: "Closed",
  }[status];
  return statusList || "Setup";
};

export const workflowField = {
  "nomineeDetails.name": "Nominee name",
  "nomineeDetails.mobileNumber": "Nominee mobile no.",
  "nomineeDetails.email": "Nominee email",
  accountHolderName: "Account holder name",
  bankName: "Bank Name",
  branch: "Branch",
  accountNumber: "Account number",
  upiId: "UPI id",
  ifsc: "IFSC",
  aadhaarNumber: "Aadhaar number",
  panNumber: "Pan number",
  address: "Address",
  city: "City",
  pinCode: "Pincode",
  name: "Name",
  mobileNumber: "Mobile number",
  email: "Email",
  nearestShowroom: "Nearest Showroom",
  dateOfMaturity: "Date of maturity",
  extendRedemptionDate: "Extend Redemption Date",
};

export const SUBSCHEME_STATUS = {
  0: "SETUP",
  1: "ACTIVE",
  SETUP: "SETUP",
  ACTIVE: "ACTIVE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  CREATE: "CREATE",
};

export const reports = [
  {
    id: 1,
    icon: "schemeReports",
    name: "Scheme Reports",
    range: "101-108",
    subModules: [
      {
        id: "101",
        name: "Passbook balance report",
        series: 100,
        nestedSubModules: [],
        path: "101-Passport-balance-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: false,
          isMasterScheme: true,
          showSubScheme: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          showStatus: true,
          showPassbookSource: true,
          isSingleDate: true,
        },
      },
      {
        id: "102",
        name: "Scheme collection report",
        series: 100,
        nestedSubModules: [],
        path: "102-Scheme-Collection-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isMasterScheme: true,
          showSubScheme: true,
          showMetric: false,
          ShowCollectionType: true,
          showReceiptType: true,
        },
      },
      {
        id: "103",
        name: "Redemption report",
        series: 100,
        nestedSubModules: [],
        path: "103-Redemption-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isMasterScheme: true,
          showSubScheme: true,
          showMetric: false,
          showStatus: true,
        },
      },
      {
        id: "104",
        name: "Customer balance report",
        series: 100,
        nestedSubModules: [],
        path: "104-Customer-Balance-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: false,
          isMasterScheme: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          showSubScheme: true,
          isSingleDate: true,
        },
      },
      {
        id: "105",
        name: "Customer summary report",
        series: 100,
        nestedSubModules: [],
        path: "105-Customer-Summary",
        filterItems: {
          isShowInput: true,
          InputLabel: "Mobile Number",
          key: "mobileNo",
          isSingleDate: true,
        },
      },
      {
        id: "106",
        name: "Passbook statement report",
        series: 100,
        nestedSubModules: [],
        path: "106-Passbook-statement-report",
        filterItems: {
          isShowInput: true,
          InputLabel: "Passbook Number",
          key: "passbookNo",
          isSingleDate: true,
        },
      },
      {
        id: "107",
        name: "Cessional passbook Report",
        series: 100,
        nestedSubModules: [],
        path: "107-Cessional-passbook-Report",
        filterItems: {
          isMasterScheme: true,
          showSubScheme: true,
          isSingleDate: true,
         
        },
      },
      {
        id: "108",
        name: "Passbook detail report",
        series: 100,
        nestedSubModules: [],
        path: "108-Passbook-detail-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isMasterScheme: true,
          showSubScheme: true,
          showStatus: true,
          showPassbookSource: true,
          isSingleDate: false,
        },
      },
    ],
  },
  {
    id: 2,
    icon: "misReport",
    name: "MIS Report",
    range: "201-209",
    subModules: [
      {
        id: "201",
        name: "Registration summary",
        series: 200,
        nestedSubModules: [],
        path: "201-Registraton-Summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: true,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "202",
        name: "Scheme customer summary",
        series: 200,
        nestedSubModules: [],
        path: "202-Scheme-customer-summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "203",
        name: "Active customer summary",
        series: 200,
        nestedSubModules: [],
        path: "203-Active-customer-summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "204",
        name: "Active passbook summary",
        series: 200,
        nestedSubModules: [],
        path: "204-Active-passbook-summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: true,
          showMetric: false,
        },
      },
      {
        id: "205",
        name: "Matured Vs redeemed %",
        series: 200,
        nestedSubModules: [],
        path: "205-Matured-Vs-redeemed-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "206",
        name: "SGS collection summary",
        series: 200,
        nestedSubModules: [],
        path: "206-SGS-collection-summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "207",
        name: "DGP Target collection report",
        series: 200,
        nestedSubModules: [],
        path: "207-DGP-Target-collection-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "208",
        name: "SGS collection pattern summary",
        series: 200,
        nestedSubModules: [],
        path: "208-SGS-collection-pattern-summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
      {
        id: "209",
        name: "SGS collection pattern",
        series: 200,
        nestedSubModules: [],
        path: "209-SGS-collection-pattern-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isConversionStatus: false,
          showSubScheme: false,
          showMetric: false,
        },
      },
    ],
  },
  {
    id: 3,
    icon: "summaryDashboards",
    name: "Summary Dashboards",
    range: "301-302",
    subModules: [
      {
        id: "301",
        name: "Daily Summary Report",
        series: 300,
        nestedSubModules: [],
        path: "301-Daily-Summary-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
        },
      },
      {
        id: "302",
        name: "Scheme Age Analysis",
        series: 300,
        nestedSubModules: [],
        path: "302-Scheme-Age-Analysis",
        filterItems: {
          isStartDate: true,
          isCustomeDatePickerSidebar: false,
          isSingleDate: true,
          isCustomeDatePickerHeader: false,
          // isEndDate: true,
        },
      },
    ],
  },
  {
    id: 4,
    icon: "trendAnalysis",
    name: "Trend Analysis",
    range: "411-429",
    subModules: [
      {
        id: 411,
        name: "MIS Trends",
        range: "411-413",
        nestedSubModules: [
          {
            id: 411,
            name: "Registration",
            series: "411",
            path: "411-Registration-Trends",
            apiPath: "regitrationTrend",
            header: "411-Registration trends",
            graphHeader: "Registration Trend",
            tableHeader: "Registration Trend",
            totalCountLabel: "Registered",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 11,
            subModuleId: 411,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Passbooks",
            legendLabel: "Registered Users",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Registered Users (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: false,
            showMetric: false,
            showType: false,
            type: "",
            show: true,
          },
          {
            id: 412,
            name: "Conversion",
            series: "412",
            path: "412-Conversion-Trends",
            header: "412-Conversion trends",
            graphHeader: "Conversion Trend",
            tableHeader: "Conversion Trend",
            apiPath: "conversionTrend",
            totalCountLabel: "Conversion %",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 11,
            subModuleId: 411,
            secondaryCountLabel: "",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Conversion %",
            legendLabel:
              "Conversion (% of Registered users having Scheme Balance)",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel:
              "Conversion (% of Registered users having Scheme Balance)(Comparison Period) ",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: false,
            showMetric: false,
            showType: false,
            type: "",
            show: true,
          },
          {
            id: 413,
            name: "Joining",
            series: "413",
            path: "413-Joining-Trends",
            apiPath: "joiningTrend",
            header: "413-Joining trends",
            graphHeader: "Joining Trend",
            tableHeader: "Joining Trend",
            totalCountLabel: "Joined",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 11,
            subModuleId: 411,
            secondaryCountLabel: "",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Passbooks",
            legendLabel: "Active Passbooks Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Passbooks Count (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 413,
            name: "Joining",
            series: "413",
            path: "413-Joining-Trends",
            apiPath: "joiningTrend",
            header: "413-Joining trends",
            graphHeader: "Joining Trend (Amount)",
            tableHeader: "Joining Trend (Amount)",
            totalCountLabel: "Amount Total",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 11,
            subModuleId: 411,
            secondaryCountLabel: "",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Amount",
            legendLabel: "Active Amount",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Amount (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
        ],
      },
      {
        id: 412,
        name: "Scheme Trends",
        range: "415-419",
        nestedSubModules: [
          {
            id: 415,
            name: "Redemption",
            series: "415",
            path: "415-Redemption-Trends",
            apiPath: "redemptionTrend",
            header: "415-Redemption Trend",
            graphHeader: "Redemption Trend",
            tableHeader: "Redemption Trend",
            totalCountLabel: "Active Total",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            subModule: 12,
            subModuleId: 412,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: true,
            xAxisLabel: "Date",
            yAxisLabel: "Passbooks",
            legendLabel: "Active Passbooks Count",
            secondaryLegendLabel: "Matured Passbooks Count",
            borderColor: "#982620",
            secondaryBorderColor: "#FFBD5C",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Passbooks Count (Comparison Period)",
            secondaryDottedLegendLabel:
              "Matured Passbooks Count (Comparison Period)",
            dottedBorderColor: "#982620",
            secondaryDottedBorderColor: "#FFBD5C",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 415,
            name: "Redemption",
            series: "415",
            path: "415-Redemption-Trends",
            apiPath: "redemptionTrend",
            header: "415-Redemption Trends (Amount)",
            graphHeader: "Redemption Trend (Amount)",
            tableHeader: "Redemption Trend (Amount)",
            totalCountLabel: "Active Total",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            subModule: 12,
            subModuleId: 412,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: true,
            xAxisLabel: "Date",
            yAxisLabel: "Amount",
            legendLabel: "Active Amount",
            secondaryLegendLabel: "Matured Amount",
            borderColor: "#982620",
            secondaryBorderColor: "#FFBD5C",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Amount (Comparison Period)",
            secondaryDottedLegendLabel: "Matured Amount (Comparison Period)",
            dottedBorderColor: "#982620",
            secondaryDottedBorderColor: "#FFBD5C",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 417,
            name: "Due Collection (Installments)",
            series: "417",
            path: "417-Due-Collection-Trends",
            apiPath: "dueCollectionTrend",
            header: "417-Due Collection Trends (Installments)",
            graphHeader: "Due Collection Trend (Installment)",
            tableHeader: "Due Collection Trend",
            totalCountLabel: "Due %",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "SGS|TML",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 12,
            subModuleId: 412,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Collection %",
            legendLabel: "Installments",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Installments (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: false,
            showType: false,
            type: "",
            show: true,
          },
          {
            id: 418,
            name: "Due Collection (Amount)",
            series: "418",
            path: "418-Due-Collection-Trends-Amount",
            apiPath: "dueCollectionAmountTrend",
            header: "418-Due Collection Trends (Amount)",
            graphHeader: "Due Collection Trend (Amount)",
            tableHeader: "Due Collection Trend (Amount)",
            totalCountLabel: "Total Overdue Amount",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "SGS|TML",
            chartType: "graph",
            showDue: true,
            secondaryLegendLabel: "Current Due Amount",
            tertiaryLegendLabel: "Advance Due Amount",
            secondaryDottedLegendLabel:
              "Current Due Amount (Comparison Period)",
            tertiaryDottedLegendLabel: "Advance Due Amount (Comparison Period)",
            subModule: 12,
            subModuleId: 412,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Amount",
            legendLabel: "Overdue Amount",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Overdue Amount (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: false,
            showType: false,
            type: "Amount",
            show: true,
          },
          {
            id: 419,
            name: "Target Collection",
            series: "419",
            path: "419-Target-Collection-Trends-Weight",
            apiPath: "targetCollectionTrend",
            header: "419-Target Collection Trends (Weight)",
            graphHeader: "Target Trend",
            tableHeader: "Target Collection Trend (Weight)",
            totalCountLabel: "Total Target",
            showTotalCountLabel: false,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "Target Saved",
            secondaryDottedLegendLabel: "Target Saved (Comparison Period)",
            subModule: 12,
            subModuleId: 412,
            secondaryCountLabel: "Total Target",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Weight",
            legendLabel: "Total Target",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Total Target(Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: false,
            showType: false,
            type: "",
            show: true,
          },
        ],
      },
      {
        id: 413,
        name: "Monthly Scheme Patterns",
        range: "421-424",
        nestedSubModules: [
          {
            id: 421,
            name: "Balance",
            series: "421",
            path: "421-Total-Scheme-Balance",
            apiPath: "schemeBalance",
            header: "421-Scheme-Balance",
            graphHeader: "Scheme Balance",
            tableHeader: "Scheme Balance",
            totalCountLabel: "",
            showTotalCountLabel: false,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "Matured Passbooks Count",
            secondaryDottedLegendLabel:
              "Matured Passbooks Count (Comparison Period)",
            subModule: 13,
            subModuleId: 413,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Passbooks",
            legendLabel: "Active Passbooks Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Passbooks Count (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 421,
            name: "Balance",
            series: "421",
            path: "421-Total-Scheme-Balance",
            apiPath: "schemeBalance",
            header: "421-Scheme-Balance",
            graphHeader: "Scheme Balance",
            tableHeader: "Scheme Balance",
            totalCountLabel: "Registered",
            showTotalCountLabel: false,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "Matured Amount",
            secondaryDottedLegendLabel: "Matured Amount (Comparison Period)",
            subModule: 13,
            subModuleId: 413,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Amount (₹)",
            legendLabel: "Active Amount",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Amount (Comparison Period)",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 423,
            name: "Consolidated Daily passbook",
            series: "423",
            path: "423-Consolidated-Daily-Passbook",
            apiPath: "consolidatedDailySummary",
            header: "423-Consolidated Daily Passbook",
            graphHeader: "Consolidated Daily Passbook",
            tableHeader: "Consolidated Daily Passbook",
            totalCountLabel: "Registered",
            showTotalCountLabel: false,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: false,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,
            secondaryLegendLabel: "Collection Count",
            secondaryDottedLegendLabel: "",
            subModule: 13,
            subModuleId: 413,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "",
            yAxisLabel: "Passbook",
            legendLabel: "Joining Count",
            tertiaryLegendLabel: "Termination Count",
            quateryLegendLabel: "Redemption Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            secondaryBorderColor: "#FFA412",
            dottedLegendLabel: "",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: true,
            type: "Count",
            show: true,
          },
          {
            id: 423,
            name: "Consolidated Daily Amount",
            series: "423",
            path: "423-Consolidated-Daily-Amount",
            apiPath: "consolidatedDailySummary",
            header: "423-Consolidated Daily Amount",
            graphHeader: "Consolidated Daily Amount",
            tableHeader: "Consolidated Daily Amount",
            totalCountLabel: "Registered",
            showTotalCountLabel: false,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: false,
            scheme: "ALL",
            chartType: "graph",
            showDue: false,

            secondaryDottedLegendLabel: "",
            subModule: 13,
            subModuleId: 413,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Date",
            yAxisLabel: "Amount",
            legendLabel: "Joining Amount",
            borderColor: "#982620",
            backgroundColor: "#982620",
            secondaryLegendLabel: "Collection Amount",
            tertiaryLegendLabel: "Termination Amount",
            quateryLegendLabel: "Redemption Amount",
            secondaryBorderColor: "#FFA412",
            dottedLegendLabel: "",
            dottedBorderColor: "#982620",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: true,
            type: "Value",
            show: false,
          },
        ],
      },
      {
        id: 414,
        name: "DGP Patterns",
        range: "431-433",
        nestedSubModules: [
          {
            id: 431,
            name: "Receipt Pattern",
            series: "431",
            path: "431-DigiGold-Receipt-Pattern",
            apiPath: "digiGoldReceiptPattern",
            header: "431-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Total Passbooks",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Age-wise Breakup",
            yAxisLabel: "Passbook Count",
            legendLabel: "Passbook Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Passbook Count (Comparison Period)",
            dottedBorderColor: "#FFA412",
            isStartDate: true,
            // isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Passbooks",
            show: true,
          },
          {
            id: 431,
            name: "Receipt Pattern",
            series: "431",
            path: "431-DigiGold-Receipt-Pattern",
            apiPath: "digiGoldReceiptPattern",
            header: "431-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Total Installments",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Age-wise Breakup",
            yAxisLabel: "Installments",
            legendLabel: "Installments",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Installments (Comparison Period)",
            dottedBorderColor: "#FFA412",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Installments",
            show: false,
          },
          {
            id: 431,
            name: "Receipt Pattern",
            series: "431",
            path: "431-DigiGold-Receipt-Pattern",
            apiPath: "digiGoldReceiptPattern",
            header: "431-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Receipt Value",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Age-wise Breakup",
            yAxisLabel: "Receipt Value",
            legendLabel: "Receipt Value",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Receipt Value (Comparison Period)",
            dottedBorderColor: "#FFA412",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 431,
            name: "Receipt Pattern",
            series: "431",
            path: "431-DigiGold-Receipt-Pattern",
            apiPath: "digiGoldReceiptPattern",
            header: "431-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Total Weight",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Age-wise Breakup",
            yAxisLabel: "Weight in g.",
            legendLabel: "Weight Saved",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Weight Saved (Comparison Period)",
            dottedBorderColor: "#FFA412",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Weight",
            show: false,
          },
          {
            id: 432,
            name: "Balance Pattern",
            series: "432",
            path: "432-DigiGold-Balance-Pattern",
            apiPath: "digiGoldBalancePattern",
            header: "432-Balance Pattern",
            graphHeader: "Balance Pattern",
            tableHeader: "Balance Pattern",
            totalCountLabel: "Active Passbook Count",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              // isEndDate: true,
              isCustomeDatePickerSidebar: false,
              isSingleDate: true,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Balance Value Range",
            yAxisLabel: "Active Passbook Count",
            legendLabel: "Active Passbook Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Passbook Count (Comparison Period)",
            dottedBorderColor: "#FFA412",
            isStartDate: true,
            // isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: true,
            type: "Count",
            show: true,
          },
          {
            id: 432,
            name: "Balance Pattern",
            series: "432",
            path: "432-DigiGold-Balance-Pattern",
            apiPath: "digiGoldBalancePattern",
            header: "432-Balance Pattern",
            graphHeader: "Balance Pattern",
            tableHeader: "Balance Pattern",
            totalCountLabel: "Active Passbook Balance",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Active Passbook Balance",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Balance Value Range",
            yAxisLabel: "Passbook Balance",
            legendLabel: "Active Passbook Balance",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Active Passbook Balance (Comparison Period)",
            dottedBorderColor: "#FFA412",
            showSubScheme: true,
            showMetric: true,
            showType: true,
            isStartDate: true,
            type: "Value",
            show: false,
          },
          {
            id: 433,
            name: "Redemption Pattern",
            series: "433",
            path: "433-DigiGold-Redemption-Pattern",
            apiPath: "digiGoldRedemptionPattern",
            header: "433-Redemption Pattern",
            graphHeader: "Redemption Pattern",
            tableHeader: "Redemption Pattern",
            totalCountLabel: "Termination Passbook Count",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Balance Value Range",
            yAxisLabel: "Termination Passbook Count",
            legendLabel: "Termination Passbook Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "Termination Passbook Count (Comparison Period)",
            dottedBorderColor: "#FFA412",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: true,
            type: "Count",
            show: true,
          },
          {
            id: 433,
            name: "Redemption Pattern",
            series: "433",
            path: "433-DigiGold-Redemption-Pattern",
            apiPath: "digiGoldRedemptionPattern",
            header: "433-Redemption Pattern",
            graphHeader: "Redemption Pattern",
            tableHeader: "Redemption Pattern",
            totalCountLabel: "Termination Passbook Value",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            scheme: "DGP",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 14,
            subModuleId: 414,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Balance Value Range",
            yAxisLabel: "Termination Passbook Value",
            legendLabel: "Termination Passbook Value",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel:
              "Termination Passbook Balance (Comparison Period)",
            dottedBorderColor: "#FFA412",
            showSubScheme: true,
            showMetric: true,
            showType: true,
            type: "Value",
            show: false,
          },
        ],
      },
      {
        id: 415,
        name: "SGS-Patterns",
        range: "441-446",
        nestedSubModules: [
          {
            id: 441,
            name: "Receipt Pattern",
            series: "441",
            path: "441-SuperGold-Receipt-Pattern",
            apiPath: "superGoldReceiptPattern",
            header: "441-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Total Installments",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            secondaryBackgroundColor: "#165BAA",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Advance Payment Count",
            tertiaryLegendLabel: "Delayed Payment Count",
            tertiaryDottedLegendLabel:
              "Delayed Payment Count (Comparison Period)",
            secondaryDottedLegendLabel:
              "Advance Payment Count(Comparison Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Passbooks",
            legendLabel: "Ontime Payment Count",
            borderColor: "#FFBD5C",
            backgroundColor: "#982620",
            dottedLegendLabel: "Ontime Payment Count(Comparison Period)",
            dottedBorderColor: "#DE8705",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 441,
            name: "Receipt Pattern",
            series: "441",
            path: "441-SuperGold-Receipt-Pattern",
            apiPath: "superGoldReceiptPattern",
            header: "441-Receipt Pattern",
            graphHeader: "Receipt Pattern",
            tableHeader: "Receipt Pattern",
            totalCountLabel: "Total Amount",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            secondaryBackgroundColor: "#165BAA",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Advance Payment Amount",
            tertiaryLegendLabel: "Delayed Payment Amount",
            tertiaryDottedLegendLabel:
              "Delayed Payment Amount (Comparison Period)",
            secondaryDottedLegendLabel:
              "Advance Payment Amount(Comparison Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Amount",
            legendLabel: "Ontime Payment Amount",
            borderColor: "#FFBD5C",
            backgroundColor: "#FFBD5C",
            dottedLegendLabel: "Ontime Payment Amount(Comparison Period)",
            dottedBorderColor: "#DE8705",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 442,
            name: "Balance Pattern",
            series: "442",
            path: "442-SuperGold-Balance-Pattern",
            apiPath: "superGoldBalancePattern",
            header: "442-Balance Pattern",
            graphHeader: "Balance Pattern",
            tableHeader: "Balance Pattern",
            totalCountLabel: "Total Passbooks",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              // isEndDate: true,
              isCustomeDatePickerSidebar: false,
              isSingleDate: true,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            secondaryBackgroundColor: "#982620",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Matured Passbook Count",
            secondaryDottedLegendLabel:
              "Matured Passbook Count (Comparison Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Value Range",
            yAxisLabel: "Passbooks",
            legendLabel: "Active Passbook Count",
            borderColor: "#FFBD5C",
            backgroundColor: "#FFBD5C",
            dottedLegendLabel: "Active Passbook Count (Comparison Period)",
            dottedBorderColor: "#FFBD5C",
            secondaryDottedBorderColor: "",

            isStartDate: true,
            // isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 442,
            name: "Balance Pattern",
            series: "442",
            path: "442-SuperGold-Balance-Pattern",
            apiPath: "superGoldBalancePattern",
            header: "442-Balance Pattern",
            graphHeader: "Balance Pattern",
            tableHeader: "Balance Pattern",
            totalCountLabel: "Scheme Balance",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            secondaryBackgroundColor: "#982620",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Matured Passbook Amount",
            secondaryDottedLegendLabel:
              "Matured Passbook Amount (Comparison Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Value Range",
            yAxisLabel: "Amount",
            legendLabel: "Active Passbook Amount",
            borderColor: "#FFBD5C",
            backgroundColor: "#FFBD5C",
            dottedLegendLabel: "Active Passbook Amount (Comparison Period)",
            dottedBorderColor: "#FFBD5C",
            secondaryDottedBorderColor: "#FFBD5C",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 443,
            name: "Redemption Pattern",
            series: "443",
            path: "443-SuperGold-Redemption-Pattern",
            apiPath: "superGoldRedemptionPattern",
            header: "443-Redemption Pattern",
            graphHeader: "Redemption Pattern",
            tableHeader: "Redemption Pattern",
            totalCountLabel: "Total Passbooks",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            secondaryBackgroundColor: "#982620",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Termination Passbook Count",
            secondaryDottedLegendLabel:
              "Termination Passbook Count(Comparative Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Value Range",
            yAxisLabel: "Passbooks",
            legendLabel: "Redemption Passbook Count",
            borderColor: "#FFBD5C",
            backgroundColor: "#FFBD5C",
            dottedLegendLabel: "Redemption Passbook Count (Comparative Period)",
            dottedBorderColor: "#FFBD5C",
            isStartDate: true,
            isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 443,
            name: "Redemption Pattern",
            series: "443",
            path: "443-SuperGold-Redemption-Pattern",
            apiPath: "superGoldRedemptionPattern",
            header: "443-Redemption Pattern",
            graphHeader: "Redemption Pattern",
            tableHeader: "Redemption Pattern",
            totalCountLabel: "Scheme Balance",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: true,
            secondaryBackgroundColor: "#982620",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Termination Passbook Amount",
            secondaryDottedLegendLabel:
              "Termination Passbook Amount(Comparative Period)",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Value Range",
            yAxisLabel: "Amount",
            legendLabel: "Redemption Passbook Amount",
            borderColor: "#FFBD5C",
            backgroundColor: "#FFBD5C",
            dottedLegendLabel: "Redemption Passbook Amount(Comparative Period)",
            dottedBorderColor: "#982620",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 444,
            name: "Installment Pattern",
            series: "444",
            path: "444-SuperGold-Installment-Pattern",
            apiPath: "superGoldInstallmentPattern",
            header: "444-Installment Pattern",
            graphHeader: "Installment Pattern",
            tableHeader: "Installment Pattern",
            totalCountLabel: "Installments Due",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              // isEndDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: false,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#26721F",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Ontime Payment Count",
            tertiaryLegendLabel: "Delayed Payment Count",
            secondaryDottedLegendLabel: "",
            quateryLegendLabel: "Current Due Count",
            quinaryLegendLabel: "Delinquent Count",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Count",
            legendLabel: "Advance Payment Count",
            borderColor: "#165BAA",
            backgroundColor: "#165BAA",
            dottedLegendLabel: "",
            dottedBorderColor: "#982620",
            isStartDate: true,
            // isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 444,
            name: "Installment Pattern",
            series: "444",
            path: "444-SuperGold-Installment-Pattern",
            apiPath: "superGoldInstallmentPattern",
            header: "444-Installment Pattern",
            graphHeader: "Installment Pattern",
            tableHeader: "Installment Pattern",
            totalCountLabel: "Total Paid",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: true,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#26721F",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Ontime Payment Amount",
            tertiaryLegendLabel: "Delayed Payment Amount",
            secondaryDottedLegendLabel: "",
            quateryLegendLabel: "Current Due Amount",
            quinaryLegendLabel: "Delinquent Amount",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Amount",
            legendLabel: "Advance Payment Amount",
            borderColor: "#165BAA",
            backgroundColor: "#165BAA",
            dottedLegendLabel: "",
            dottedBorderColor: "",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
          {
            id: 445,
            name: "Dues Pattern",
            series: "445",
            path: "445-SuperGold-Dues-Pattern",
            apiPath: "superGoldDuesPattern",
            header: "445-Dues Pattern",
            graphHeader: "Dues Pattern",
            tableHeader: "Dues Pattern",
            totalCountLabel: "Registered",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: false,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#982620",
            QuaternaryBackgroundColor: "#26721F",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Ontime Payment Count",
            tertiaryLegendLabel: "Delayed Payment Count",
            quateryLegendLabel: "Current Due Count",
            quinaryLegendLabel: "Delinquent Count",
            secondaryDottedLegendLabel: "",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Value Range",
            yAxisLabel: "Count",
            legendLabel: "Advance Payment Count",
            borderColor: "#165BAA",
            backgroundColor: "#165BAA",
            dottedLegendLabel: "",
            dottedBorderColor: "",
            showSubScheme: true,
            showMetric: true,
            type: "Count",
            show: true,
          },
          {
            id: 445,
            name: "Dues Pattern",
            series: "445",
            path: "445-SuperGold-Dues-Pattern",
            apiPath: "superGoldDuesPattern",
            header: "445-Dues Pattern",
            graphHeader: "Dues Pattern",
            tableHeader: "Dues Pattern",
            totalCountLabel: "Installments Due",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isEndDate: true,
            },
            showCompare: false,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#FFBD5C",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "Ontime Payment Amount",
            tertiaryLegendLabel: "Delayed Payment Amount",
            quateryLegendLabel: "Current Due Amount",
            quinaryLegendLabel: "Delinquent Amount",
            secondaryDottedLegendLabel: "",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Amount",
            legendLabel: "Advance Payment Amount",
            borderColor: "#165BAA",
            backgroundColor: "#165BAA",
            dottedLegendLabel: "",
            dottedBorderColor: "",
            showSubScheme: true,
            showMetric: true,
            type: "Value",
            show: false,
          },
          {
            id: 446,
            name: "Delay Pattern",
            series: "446",
            path: "446-SuperGold-Delay-Pattern",
            apiPath: "superGoldDelayPattern",
            header: "446-Delay Pattern",
            graphHeader: "Delay Pattern",
            tableHeader: "Delay Pattern",
            totalCountLabel: "Total delay dues Count",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              // isEndDate: false,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: false,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#FFBD5C",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "No. of Installment",
            legendLabel: "Delay Installment Count",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "",
            dottedBorderColor: "#982620",
            isStartDate: true,
            // isEndDate: true,
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Count",
            show: true,
          },
          {
            id: 446,
            name: "Delay Pattern",
            series: "446",
            path: "446-SuperGold-Delay-Pattern",
            apiPath: "superGoldDelayPattern",
            header: "446-Delay Pattern",
            graphHeader: "Delay Pattern",
            tableHeader: "Delay Pattern",
            totalCountLabel: "Total Installment Amount",
            showTotalCountLabel: true,
            dataToAdd: true,
            filterItems: {
              isStartDate: true,
              isSingleDate: true,
              isCustomeDatePickerSidebar: false,
              isCustomeDatePickerHeader: false,
            },
            showCompare: false,
            secondaryBackgroundColor: "#FFBD5C",
            tertiaryBackgroundColor: "#FFBD5C",
            QuaternaryBackgroundColor: "#FFBD5C",
            scheme: "SGS",
            chartType: "bar",
            showDue: false,
            secondaryLegendLabel: "",
            secondaryDottedLegendLabel: "",
            subModule: 15,
            subModuleId: 415,
            secondaryCountLabel: "Matured Total",
            showSecondaryCountLabel: false,
            xAxisLabel: "Installment No.",
            yAxisLabel: "Value of Overdue Installments",
            legendLabel: "Delay Installment Amount",
            borderColor: "#982620",
            backgroundColor: "#982620",
            dottedLegendLabel: "",
            isStartDate: true,
            // isEndDate: true,
            dottedBorderColor: "#982620",
            showSubScheme: true,
            showMetric: true,
            showType: false,
            type: "Value",
            show: false,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    icon: "monthlySummary",
    name: "Monthly Summary",
    range: "501-504",
    subModules: [
      {
        id: "501",
        name: "Summary Balance Report",
        series: 500,
        nestedSubModules: [],
        path: "501-Summary-Balance-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
      {
        id: "502",
        name: "Monthly Summary Collection",
        series: 500,
        nestedSubModules: [],
        path: "502-Monthly-Summary-Collection",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
      {
        id: "503",
        name: "Daily Summary Collection",
        series: 500,
        nestedSubModules: [],
        path: "503-Daily-Summary-Collection",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
        },
      },
      {
        id: "504",
        name: "Scheme Wise Daily Summary Report",
        series: 500,
        nestedSubModules: [],
        path: "504-Scheme-Wise-Daily-Summary-Report",
        filterItems: {
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerTypeMonth: "month",
          pickerTypeYear: "year",
          isSingleDate: true,
        },
      },
    ],
  },
  {
    id: 6,
    icon: "financialYearReport",
    name: "Financial Year Report",
    range: "601-604",
    subModules: [
      {
        id: "601",
        name: "Conversion Tracker",
        series: 600,
        nestedSubModules: [],
        path: "601-Conversion-Tracker",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
      {
        id: "602",
        name: "Collection Matrix",
        series: 600,
        nestedSubModules: [],
        path: "602-Collection-Matrix",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
      {
        id: "603",
        name: "Savings Pattern Trend",
        series: 600,
        nestedSubModules: [],
        path: "603-Savings-Pattern-Trend",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
      {
        id: "604",
        name: "Value Trend",
        series: 600,
        nestedSubModules: [],
        path: "604-Value-Trend",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          isCustomeDatePickerSidebar: false,
          isCustomeDatePickerHeader: false,
          pickerType: "month",
        },
      },
    ],
  },
  {
    id: 7,
    icon: "rewardReport",
    name: "Reward Report",
    range: "701-704",
    subModules: [
      {
        id: "701",
        name: "Reward report",
        series: 700,
        path: "701-Rewards-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
        },
        nestedSubModules: [],
      },
      {
        id: "702",
        name: "Rewards Conversion",
        series: 700,
        path: "702-Rewards-Conversion",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
        },
        nestedSubModules: [],
      },
      {
        id: "703",
        name: "Reward Value Tracking",
        series: 700,
        path: "703-Reward-Value-Tracking",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
        },
        nestedSubModules: [],
      },
      {
        id: "704",
        name: "scheme reward",
        series: 700,
        path: "704-scheme-reward",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          showSubScheme: true,
        },
        nestedSubModules: [],
      },
    ],
  },
  {
    id: 8,
    icon: "KYCUpdationReports",
    name: "Common Reports",
    range: "800",
    subModules: [
      {
        id: "801",
        name: "KYC Reports",
        series: 800,
        path: "kycTable",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          showSourceType: true,
          isShowInput: true,
          InputLabel: "Approved By",
          key: "approvedBy",
        },
        nestedSubModules: [],
      },
      // {
      //   id: "802",
      //   name: "Recipt Reconciliation Reports",
      //   series: 800,
      //   path: "recieptReconciliation",
      //   filterItems: {
      //     isStartDate: true,
      //     isEndDate: true,
      //     showreconciliationType: true,
      //     isShowInput: true,
      //     InputLabel: "Maker By",
      //     key: "makerName",
      //   },
      //   nestedSubModules: [],
      // },
      {
        id: "803",
        name: "PAN /Adhar verified customer Report",
        series: 800,
        path: "adharPanVerifiedCustomer",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "804",
        name: "Email verified customer report",
        series: 800,
        path: "emailVerifiedCustomer",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "805",
        name: "Review Submission Report",
        series: 800,
        path: "reviewSubmissionReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "806",
        name: "Customer profile Report",
        series: 800,
        path: "customerProfileReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "807",
        name: "Data Delection  report",
        series: 800,
        path: "dataDelectionReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "808",
        name: "Zerobounce usage report",
        series: 800,
        path: "zerobounceUsageReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
        nestedSubModules: [],
      },
      {
        id: "809",
        name: "Surepass usage report",
        series: 800,
        path: "surepasslogs",
        filterItems: {
          isStartDate: true,
          isEndDate: true,

        },
          nestedSubModules: [],
      },
      {
        id: "810",
        name: "Call back request report",
        series: 800,
        path: "callBackRequestReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          showSchemeType: true,
        },
        nestedSubModules: [],
      },
    ],
  },
  {
    id: 9,
    icon: "downloadReport",
    name: "Download Dump",
    range: "900",
    subModules: [
      // {
      //   id: "901",
      //   name: "Download Report",
      //   series: 900,
      //   path: "Download%20Report",
      //   filterItems: {
      //     isStartDate: true,
      //     isEndDate: true,
      //   },
      //   nestedSubModules: [],
      // },
      {
        id: "901",
        name: "User List Dump",
        series: 900,
        // path: "Download%20Report",
        filterItems: {
          isExport: true,
          isStartDate: true,
          isEndDate: true,
        },
        nestedSubModules: [],
      },
      {
        id: "902",
        name: "Payment List Dump",
        series: 900,
        // path: "Download%20Report",
        filterItems: {
          isExport: true,
          isStartDate: true,
          isEndDate: true,
        },
        nestedSubModules: [],
      },
    ],
  },
  {
    id: 10,
    icon: "monthlySummary",
    name: "Schedule Reports",
    range: "1000",
    subModules: [
      {
        id: "1001",
        name: "Mandate Report",
        series: 1000,
        path: "1001-Mandate-Report",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          showSheduleType: false,
          showMandateDetails: true

        },

        nestedSubModules: [],
      },
      {
        id: "1002",
        name: "Mandate Presented Report",
        series: 1000,
        path: "1002-Mandate-PresentedReport",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          showSheduleType: false,
          showMandatePresentedDetails: true
        },
        nestedSubModules: [],
      },
      {
        id: "1003",
        name: "Token payments",
        series: 1000,
        path: "1003-token-payments",
        filterItems: {
          isStartDate: true,
          isEndDate: true,
          // showSheduleType: true,
          showMandatereconicationDetails: true
        },
        nestedSubModules: [],
      },
    ],
  },

];

export const calenderDetails = {
  startDate: null,
  endDate: null,
  comparisonStartDate: null,
  comparisonEndDate: null,
  isToggleButton: true,
  isInputHeader: true,
  compare: false,
  month: null,
  year: null,
  isPackegeDateClicked: false,
};
export const calenderDetailsforSurePass = {
  startDate: null,
  endDate: null,
  isToggleButton: false,
  isInputHeader: true,
  activePage: 1,
};

export const nestedSubModuleGraphDetails = {
  DGP: {
    432: {
      Active: {
        Value: {
          totalCountLabel: "Active Passbook Value",
          legendLabel: "Active Passbook Value",
          yAxisLabel: "Active Passbook Value",
          dottedLegendLabel: "Active Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Active Passbook Count",
          yAxisLabel: "Active Passbook Count",
          legendLabel: "Active Passbook Count",
          dottedLegendLabel: "Active Passbook Count (Comparison Period)",
        },
      },
      Matured: {
        Value: {
          totalCountLabel: "Matured Passbook Value",
          legendLabel: "Matured Passbook Value",
          yAxisLabel: "Matured Passbook Value",
          dottedLegendLabel: "Matured Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Matured Passbook Count",
          legendLabel: "Matured Passbook Count",
          yAxisLabel: "Matured Passbook Count",
          dottedLegendLabel: "Matured Passbook Count (Comparison Period)",
        },
      },
      Total: {
        Value: {
          totalCountLabel: "Total Passbook Value",
          legendLabel: "Total Passbook Value",
          yAxisLabel: "Total Passbook Value",
          dottedLegendLabel: "Total Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Total Passbook Count",
          yAxisLabel: "Total Passbook Count",
          legendLabel: "Total Passbook Count",
          dottedLegendLabel: "Total Passbook Count (Comparison Period)",
        },
      },
    },
    433: {
      Termination: {
        Value: {
          totalCountLabel: "Termination Passbook Value",
          legendLabel: "Termination Passbook Value",
          yAxisLabel: "Termination Passbook Value",
          dottedLegendLabel: "Termination Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Termination Passbook Count",
          yAxisLabel: "Termination Passbook Count",
          legendLabel: "Termination Passbook Count",
          dottedLegendLabel: "Termination Passbook Count (Comparison Period)",
        },
      },
      Redemption: {
        Value: {
          totalCountLabel: "Redemption Passbook Value",
          yAxisLabel: "Redemption Passbook Value",
          legendLabel: "Redemption Passbook Value",
          dottedLegendLabel: "Redemption Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Redemption Passbook Count",
          yAxisLabel: "Redemption Passbook Count",
          legendLabel: "Redemption Passbook Count",
          dottedLegendLabel: "Redemption Passbook Count (Comparison Period)",
        },
      },
      Total: {
        Value: {
          totalCountLabel: "Total Passbook Value",
          legendLabel: "Total Passbook Value",
          yAxisLabel: "Total Passbook Value",
          dottedLegendLabel: "Total Passbook Value (Comparison Period)",
        },
        Count: {
          totalCountLabel: "Total Passbook Count",
          legendLabel: "Total Passbook Count",
          yAxisLabel: "Total Passbook Count",
          dottedLegendLabel: "Total Passbook Count (Comparison Period)",
        },
      },
    },
  },
  "SGS|TML": {
    418: {
      "All Dues": {
        legendLabel: "Overdue Amount",
        dottedLegendLabel: "Overdue Amount (Comparison Period)",
        secondaryLegendLabel: "Current Due Amount",
        tertiaryLegendLabel: "Advance Due Amount",
        secondaryDottedLegendLabel: "Current Due Amount (Comparison Period)",
        tertiaryDottedLegendLabel: "Advance Due Amount (Comparison Period)",
        totalCountLabel: "Total All Dues Amount",
      },
      "Over Due": {
        legendLabel: "Overdue Amount",
        dottedLegendLabel: "Overdue Amount (Comparison Period)",
        totalCountLabel: "Total Overdue Amount",
      },
      "Current Due": {
        legendLabel: "Current Due Amount",
        dottedLegendLabel: "Current Due Amount (Comparison Period)",
        totalCountLabel: "Total Current Due Amount",
      },
      Advance: {
        legendLabel: "Advance Due Amount",
        dottedLegendLabel: "Advance Due Amount (Comparison Period)",
        totalCountLabel: "Total Advance Due Amount",
      },
    },
  },
  ALL: {
    423: {
      Joining: {
        Value: {
          legendLabel: "Joining Value",
          yAxisLabel: "Joining Value",
        },
        Count: {
          legendLabel: "Joining Count",
          yAxisLabel: "Joining Count",
        },
      },
      Collection: {
        Value: {
          legendLabel: "Collection Value",
          yAxisLabel: "Collection Value",
        },
        Count: {
          legendLabel: "Collection Count",
          yAxisLabel: "Collection Count",
        },
      },
      Termination: {
        Value: {
          legendLabel: "Termination Value",
          yAxisLabel: "Termination Value",
        },
        Count: {
          legendLabel: "Termination Count",
          yAxisLabel: "Termination Count",
        },
      },
      Redemption: {
        Value: {
          legendLabel: "Redemption Value",
          yAxisLabel: "Redemption Value",
        },
        Count: {
          legendLabel: "Redemption Count",
          yAxisLabel: "Redemption Count",
        },
      },
      Matured: {
        Value: {
          legendLabel: "Matured Value",
          yAxisLabel: "Matured Value",
        },
        Count: {
          legendLabel: "Matured Count",
          yAxisLabel: "Matured Count",
        },
      },
    },
  },
};

export const schemeDetails = {
  masterScheme: null,
  masterSchemeList: [],
  selectedMasterScheme: null,

  subScheme: null,
  subSchemesList: [],
  selectedSubScheme: null,
  subSchemeId: null,
  metricsList: [
    {
      label: "Count",
      value: "count",
    },
    {
      label: "Value",
      value: "value",
    },
  ],
  metric: null,
  selectedMetric: null,
  statusList: [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Registered",
      value: "0",
    },
    {
      label: "Joined",
      value: "1",
    },
  ],
  status: null,
  selectedStatus: null,
  sourceList: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Admin",
      value: "Admin",
    },
    {
      label: "Customer",
      value: "Customer",
    },
    {
      label: "GPP",
      value: "GPP",
    },
  ],
  source: null,
  selectedSource: null,
  typeList: [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Matured",
      value: "matured",
    },
  ],
  type: null,
  selectedType: null,
  dueTypeList: [
    {
      label: "All Dues",
      value: "All Dues",
    },
    {
      label: "Over Due",
      value: "Over Due",
    },
    {
      label: "Current Due",
      value: "Current Due",
    },
    {
      label: "Advance",
      value: "Advance",
    },
  ],
  dueType: null,
  selectedDueType: null,

  normalStatusForSchemeList: [
    { label: "Select All", value: "" },
    { label: "Active", value: "active" },
    { label: "Matured", value: "matured" },
    { label: "Inactive", value: "inactive" },
    // { label: "Redeemed", value: "redeemed" },
    { label: "Cancelled(Closed)", value: "cancelled" },
  ],
  normalStatusForScheme: null,

  selectedNormalStatusForScheme: null,

  passbookBalanceStatusList: [
    { label: "All", value: "" },

    { label: "App", value: "0" },
    { label: "Showroom", value: "1" },
  ],

  passbookBalanceStatus: null,
  selectedPassbookBalanceStatus: null,
  collectionTypeList: [
    { label: "All", value: "" },
    { label: "1st Payment", value: "isFirst" },
    { label: "Reward", value: "reward" },
    { label: "Collection", value: "excludeIsFirst" },
    { label: "Receipt cancel", value: "cancelled" },
  ],
  collectionType: null,
  selectedCollectionType: null,
  receiptTypeList: [
    { label: "All", value: "" },
    { label: "Razor Pay", value: "0" },
    { label: "GPP", value: "1" },
  ],
  receiptType: null,
  selectedReceiptType: null,
  scheduleTypeList: [
    { label: "All", value: "" },
    { label: "DGP", value: "DGP" },
    { label: "SGS", value: "SGS" },
  ],
  scheduleType: null,
  selectedScheduleType: null,
  mandateStatusList: [
    { label: "All", value: "" },
    { label: "Live", value: "LIVE" },
    { label: "Hold", value: "HOLD" },
    { label: "Cancelled", value: "CANCELLED" },
    { label: "Completed", value: "COMPLETED" },
  ],
  mandateStatus: null,
  selectedMandateStatus: null,
  mandatePresentedStatusList: [
    { label: "All", value: "" },
    { label: "Presented", value: "PRESENTED" },
    { label: "Success", value: "SUCCESS" },
    { label: "Failure", value: "FAILURE" },
  ],
  mandatePresentedStatus: null,
  selectedMandatePresentedStatus: null,
  mandateReconicationStatusList: [
    { label: "All", value: "" },
    { label: "Created", value: 1 },
    { label: "Captured", value: 2 },
    { label: "Failed", value: 3 },
    { label: "Refunded", value: 7 },
  ],
  mandateReconicationStatus: null,
  selectedMandateReconicationStatus: null,
  schemeTypeList: [
    { label: "ALL", value: "ALL" },
    { label: "SGP", value: "SGP" },
    { label: "EMP", value: "EMP" },
  ],
  schemeType: null,
  selectedSchemeType: null

};
export const schemeDetailsTransactionStatusOptions = [
  { label: "All", value: "1|2|3|4" },
  { label: "Success", value: "2" }, //success
  { label: "Failed", value: "3" }, //Failed
];
export const schemeDetailsTypeOptions = [
  { label: "All", value: "" },
  { label: "Reciept", value: false },
  { label: "Reward", value: true },
];

export const tabConfig = {
  agentMapping: {
    title: "Agent Mapping",
    placeholder: "Search by Zendesk Agent ID,Ozonetel Agent ID",
    headers: [
      { label: "SN", value: "sn" },
      // { label: "Agent Name", value: "name" },
      // { label: "Employee ID", value: "empId" },
      { label: "Zendesk Agent ID", value: "zendeskOwnerId" },
      { label: "Ozonetel Agent ID", value: "ozonetelAgentId" },
      { label: "Action", value: "action" },
    ],
    formFields: [
      {
        name: "zendeskOwnerId",
        label: "Zendesk Agent ID",
        component: "InputBox",
        type: "text",
        placeholder: "Enter Zendesk Agent ID",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      {
        name: "ozonetelAgentId",
        label: "Ozonetel Agent ID",
        component: "InputBox",
        type: "text",
        placeholder: "Enter Ozonetel Agent ID",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      // Add more fields
    ],

    renderRow: (item, index, activePage, onEdit, onDelete, isEditAllowed) => {
      const sNo = index + 1 + (activePage - 1) * 10;
      return (
        <tr key={item._id || index}>
          <td>{sNo}</td>
          {/* <td>{item.name}</td>
          <td>{item.empId}</td> */}
          <td>{item.zendeskOwnerId}</td>
          <td>{item.ozonetelAgentId}</td>
          {isEditAllowed && (
            <td>
              <div className="d-flex justify-content-center gap-3">
                <img
                  src={icons?.edit}
                  className="img-fluid cursor-pointer"
                  onClick={() => onEdit(item)}
                  alt="edit"
                />
                <img
                  src={icons?.userDelete}
                  className="img-fluid cursor-pointer"
                  onClick={() => onDelete(item._id)}
                  alt="delete"
                />
              </div>
            </td>
          )}
        </tr>
      );
    },
  },
  campaignMapping: {
    title: "Event to campaign mapping",
    placeholder: "Search by Event Name,Campaign Name",
    headers: [
      { label: "SN", value: "sn" },
      { label: "Event Name", value: "eventName" },
      { label: "Campaign Name", value: "campaignName" },
      { label: "Status", value: "status" },
      { label: "Skill", value: "skillName", isArray: true },
      { label: "Start Time", value: "fromTime" },
      { label: "To Time", value: "toTime" },
      { label: "Priority", value: "priority" },
      { label: "PriorityLevel", value: "prioritylevel" },
      { label: "Campaign Run Time (min)", value: "campRunTime" },
      { label: "Action", value: "action" },
    ],
    formFields: [
      {
        name: "eventName",
        label: "Event Name",
        component: "InputBox",
        type: "text",
        placeholder: "Enter Event Name",
        validation: {
          required: true,
          minLength: 2,
        },
        messages: {
          required: "Required",
          minLength: "Must be at least 2 characters",
        },
      },
      {
        name: "campaignName",
        label: "Campaign Name",
        component: "InputBox",
        type: "text",
        placeholder: "Enter Campaign Name",
        validation: {
          required: true,
          minLength: 2,
        },
        messages: {
          required: "Required",
          minLength: "Must be at least 2 characters",
        },
      },
      {
        name: "status",
        label: "Status",
        component: "CommonSelect",
        options: [
          { label: "Active", value: "Active" },
          { label: "Pause", value: "Pause" },
          { label: "Stop", value: "Stop" },
        ],
        isMulti: false,
        returnObject: false,
        validation: { required: "Status is required" },
        messages: { required: "Status is required" },
      },
      {
        name: "skillName",
        label: "Skill",
        component: "CommonSelect",
        loadOptions: true,
        options: async () => {
          const rawOptions = await fetchCrmTableData("", "skillNameMapping");
          console.log("Fetched Zendesk Group Mapping Data:", rawOptions);
          return rawOptions.list.map((g) => ({
            label: g.skillName,
            value: g.skillName,
          }));
        },
        isMulti: false,
        returnObject: false,
        validation: { required: "Required" },
        messages: { required: "Required" },
      },
      {
        name: "fromTime",
        label: "Start Time",
        component: "CommonSelect",
        options: () => numberOptions(1, 24),
        isMulti: false,
        returnObject: false,
        validation: { required: "Start Time is required" },
        messages: { required: "Start Time is required" },
      },
      {
        name: "toTime",
        label: "To Time",
        component: "CommonSelect",
        options: () => numberOptions(1, 24),
        isMulti: false,
        returnObject: false,
        validation: { required: "To Time is required" },
        messages: { required: "To time is required" },
      },
      {
        name: "priority",
        label: "Priority",
        component: "CommonSelect",
        options: () => numberOptions(0, 100),
        isMulti: false,
        returnObject: false,
        validation: { required: "Proirity is required" },
        messages: { required: "Priority is required" },
      },
      {
        name: "prioritylevel",
        label: "Priority Level",
        component: "CommonSelect",
        options: () => numberOptions(0, 100),
        isMulti: false,
        returnObject: false,
        validation: { required: "Proirity Level is required" },
        messages: { required: "Priority Level is required" },
      },
      {
        name: "campRunTime",
        label: "Campaign Run Time (min)",
        component: "CommonSelect",
        options: () => numberOptions(0, 100),
        isMulti: false,
        returnObject: false,
        validation: { required: "Campaign Run Time (min) is required" },
        messages: { required: "Campaign Run Time (min) is required" },
      },
    ],

    renderRow: (item, index, activePage, onEdit, onDelete, isEditAllowed) => {
      const sNo = index + 1 + (activePage - 1) * 10;
      return (
        <tr key={item._id || index}>
          <td>{sNo}</td>
          <td>{item.eventName}</td>
          <td>{item.campaignName}</td>
          <td>{item.status}</td>
          <td>
            {Array.isArray(item.skillName)
              ? item.skillName.join(", ")
              : item.skillName}
          </td>
          <td>{item.fromTime ?? "-"}</td>
          <td>{item.toTime ?? "-"}</td>
          <td>{item.prioritylevel ?? "-"}</td>
          <td>{item.priority ?? "-"}</td>
          <td>{item.campRunTime ?? "-"}</td>

          {isEditAllowed && (
            <td>
              <div className="d-flex justify-content-center gap-3">
                <img
                  src={icons?.edit}
                  className="img-fluid cursor-pointer"
                  onClick={() => onEdit(item)}
                  alt="edit"
                />
                <img
                  src={icons?.userDelete}
                  className="img-fluid cursor-pointer"
                  onClick={() => onDelete(item._id)}
                  alt="delete"
                />
              </div>
            </td>
          )}
        </tr>
      );
    },
  },
  // Repeat for other tabs
  zendeskGroupMapping: {
    title: "Zendesk Group Mapping",
    placeholder: "Search by Group Name",
    headers: [
      { label: "SN", value: "sn" },
      { label: "Group Name", value: "groupName" },
      { label: "Group ID", value: "zendeskGroupId" },
      { label: "Description", value: "description" },
      { label: "Action", value: "action" },
    ],
    formFields: [
      {
        label: "Group Name",
        name: "groupName",
        component: "InputBox",
        placeholder: "Enter Zendesk Group Name",
        type: "text",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      {
        label: "Group ID",
        name: "zendeskGroupId",
        component: "InputBox",
        placeholder: "Enter Zendesk Group ID",
        type: "text",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      {
        label: "description",
        name: "description",
        component: "TextArea",
        placeholder: "Enter description",
        type: "textarea",
        validation: {
          required: false,
        },
        messages: {
          required: "Required",
        },
      },
    ],
    renderRow: (item, index, activePage, onEdit, onDelete, isEditAllowed) => {
      const sNo = index + 1 + (activePage - 1) * 10;
      return (
        <tr key={item._id || index}>
          <td>{sNo}</td>
          <td>{item.groupName}</td>
          <td>{item.zendeskGroupId}</td>
          <td>{item.description}</td>
          {isEditAllowed && (
            <td>
              <div className="d-flex justify-content-center gap-3">
                <img
                  src={icons?.edit}
                  className="img-fluid cursor-pointer"
                  onClick={() => onEdit(item)}
                  alt="edit"
                />
                <img
                  src={icons?.userDelete}
                  className="img-fluid cursor-pointer"
                  onClick={() => onDelete(item._id)}
                  alt="delete"
                />
              </div>
            </td>
          )}
        </tr>
      );
    },
  },
  skillNameMapping: {
    title: "Skill Name Mapping",
    placeholder: "Search by Skill Name",
    headers: [
      { label: "SN", value: "sn" },
      { label: "Skill Name", value: "skillName" },
      { label: "Zendesk Group Name", value: "zendeskGroupId" },
      { label: "Action", value: "action" },
    ],
    formFields: [
      {
        label: "Skill Name",
        name: "skillName",
        component: "InputBox",
        type: "text",
        placeholder: "Enter Skill Name",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      {
        name: "zendeskGroupId",
        label: "Zendesk Group Id",
        component: "CommonSelect",
        isMulti: false,
        loadOptions: true,
        options: async () => {
          const rawOptions = await fetchCrmTableData("", "zendeskGroupMapping");
          console.log("Fetched Zendesk Group Mapping Data:", rawOptions);
          return rawOptions.list.map((g) => ({
            label: g.groupName,
            value: g._id,
          }));
        },
        returnObject: false,
        validation: { required: "Zendesk GroupId is required" },
        messages: { required: "Zendesk GroupId is required" },
      },
    ],
    renderRow: (item, index, activePage, onEdit, onDelete, isEditAllowed) => {
      const sNo = index + 1 + (activePage - 1) * 10;
      const skillName = item.skillName ? item.skillName : "-";
      const zendeskGroupId = item.zendeskGroupId?.groupName
        ? item.zendeskGroupId?.groupName
        : "-";

      return (
        <tr key={item._id || index}>
          <td>{sNo}</td>
          <td>{skillName}</td>
          <td>{zendeskGroupId}</td>
          {isEditAllowed && (
            <td>
              <div className="d-flex justify-content-center gap-3">
                <img
                  src={icons?.edit}
                  className="img-fluid cursor-pointer"
                  onClick={() => onEdit(item)}
                  alt="edit"
                />
                <img
                  src={icons?.userDelete}
                  className="img-fluid cursor-pointer"
                  onClick={() => onDelete(item._id)}
                  alt="delete"
                />
              </div>
            </td>
          )}
        </tr>
      );
    },
  },
  ozonetelUpload: {
    title: "Ozonetel Upload",
    formFields: [
      {
        name: "file",
        label: "Upload File",
        component: "FileUpload",
        validation: {
          required: true,
        },
        messages: {
          required: "Required",
        },
      },
      {
        name: "campaignName",
        component: "InputBox",
        label: "Campaign Name",
        placeholder: "Enter Campaign Name",
        validation: {
          required: true,
        },
        messages: {
          required: "Campaign name is required",
        },
      },
    ],
  },
};
